import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';

export default function topbarSlider() {
  const swiperContainer = document.querySelector('.site-header__topbar.swiper') as HTMLElement;

  if (window.innerWidth >= 768) return;

  if (!swiperContainer) return;

  const prevEl = swiperContainer.querySelector('.swiper-button-prev') as HTMLElement | null;
  const nextEl = swiperContainer.querySelector('.swiper-button-next') as HTMLElement | null;

  new Swiper(swiperContainer, {
    modules: [Navigation, Autoplay, EffectFade],
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 2000,
    },
    navigation: {
      prevEl,
      nextEl,
    },
  });
}
